module.exports = __webpack_public_path__ + "static/media/arrow-left.1e25543c.svg";